// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__zPckM","footerText":"Footer_footerText__L685o","cookieButton":"Footer_cookieButton__ILkts"};